<template>
<form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>{{ $t('Add.Image.Image') }}Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="qrUrl">QR Code URL</label>
      <input type="text" id="qrUrl" v-model="sharedData.data.props.url" />
    </div>
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
    </div>
    </div>
    <!-- Reiter: Style -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('style')" class="accordion-content">
      <div class="divider">
      <label class="contentLabel" for="height">{{ $t('Add.Qr.Size') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="400" v-model="size" class="slider" id="height" />
        <span>{{ size }} px</span>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('positioning')" class="accordion-content">
    <AlignmentProp :sharedData="sharedData" />
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import AlignmentProp from './AddProps/AlignmentProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
export default {
    name: 'AddQr',
  components: {
    PaddingProp,
    NameProp,
    ClassNamesProp,
    AlignmentProp,
    CopyBlock,
  },
  props: ['sharedData'],
  data() {
    return {
      //activeSections: ['main'], // Default aktivierter Reiter
    }
  },
  computed: {
    ...mapGetters(['getEmailData']),
    url: {
      get() {
        return this.sharedData?.data?.props?.link || '';
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.link = value;
      },
    },
    size: {
        get() {
        return this.sharedData?.data?.props?.size || 128;
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.size = value;
      }, 
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
}, 
methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
}
}
</script>

<style>

</style>